import { createFileRoute } from '@tanstack/react-router';
import { ActiveSalesOrdersPage } from '@/app/(client)/orders/-components/ActiveSalesOrdersPage';
import { salesOrdersQueryOptions } from '@/app/(client)/orders/-hooks/useSalesOrdersList';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(list)/sales-orders/active/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    aiSummaryId:
      typeof search.aiSummaryId === 'string' ? search.aiSummaryId : undefined,
    aiOrderNumber:
      typeof search.aiOrderNumber === 'string'
        ? search.aiOrderNumber
        : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
  }),
  loader: () =>
    queryClient.ensureQueryData(
      salesOrdersQueryOptions({ page: 1, limit: 50, isArchived: false }),
    ),
  component: ActiveSalesOrdersPage,
});
